import { lazy } from "react";
import { Navigate, Outlet, Route } from "react-router-dom";
import MainLayout from "./layouts/main-layout";
import PrivateRoute from "./private-route";

const BrokerPortalCommissionInvoices = lazy(
  () => import("../modules/BrokerPortal/CommissionInvoice"),
);
const CommissionInvoiceDetail = lazy(
  () => import("../modules/BrokerPortal/CommissionInvoice/Detail"),
);
const BrokerPortalDashboard = lazy(
  () => import("../modules/BrokerPortal/Dashboard"),
);
const BrokerPortalEmployers = lazy(
  () => import("../modules/BrokerPortal/Employers"),
);
const EmployerCommissionInvoices = lazy(
  () =>
    import("../modules/BrokerPortal/Employers/employerMain/Tabs/CommissionInvoice"),
);
const EmployerDetails = lazy(
  () => import("../modules/BrokerPortal/Employers/employerMain/Tabs/Employees"),
);
const EmployerInvoices = lazy(
  () => import("../modules/BrokerPortal/Employers/employerMain/Tabs/Invoices"),
);
const BrokerPortalPaymentOptions = lazy(
  () => import("../modules/BrokerPortal/PaymentOptions"),
);
const Agreements = lazy(
  () =>
    import("../modules/Admin/Affiliate/ProvidersAndGroup/Teledoc_health/ChargeCategories/index"),
);
const EmployeeUploads = lazy(
  () =>
    import("../modules/BrokerPortal/Employers/employerMain/Tabs/EmployeeUploads"),
);
const CommissionBreakdown = lazy(
  () =>
    import("../modules/BrokerPortal/Employers/employerMain/Tabs/CommissionBreakdown"),
);
const EnrollmentHistory = lazy(
  () =>
    import("../modules/BrokerPortal/Employers/employerMain/Tabs/EnrollmentHistory"),
);
const EmployerEmployeeMainWrapper = lazy(
  () =>
    import("../modules/BrokerPortal/Employers/employerMain/Tabs/Employees/EmployeeMain"),
);
const BrokerPortalEmployerMainWrapper = lazy(
  () => import("../modules/BrokerPortal/Employers/employerMain"),
);
const EmployeeBasicDetails = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/BasicsDetails"),
);
const BrokerPortalSignup = lazy(
  () =>
    import("../modules/BrokerPortal/Employers/employerMain/Tabs/Employees/BrokerSignup"),
);
const ProcessedRows = lazy(
  () =>
    import("../modules/BrokerPortal/Employers/employerMain/Tabs/EmployeeUploads/Tabs/ProcessedRows"),
);
const DetailedRows = lazy(
  () =>
    import("../modules/BrokerPortal/Employers/employerMain/Tabs/EmployeeUploads/Tabs/DetailedRows"),
);
const BrokerInvoiceLayout = lazy(
  () => import("../common/components/InvoiceLayout/BrokerInvoiceLayout"),
);
const EmployerInvoiceLayout = lazy(
  () => import("../common/components/InvoiceLayout/EmployerInvoiceLayout"),
);

const MainRoute = () => (
  <PrivateRoute>
    <MainLayout>
      <Outlet />
    </MainLayout>
  </PrivateRoute>
);

const BrokerPortalRoutes = (
  <>
    <Route path="/broker-portal/agent/:agentUuid" element={<MainRoute />}>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<BrokerPortalDashboard />} />
      <Route path="employers" element={<BrokerPortalEmployers />} />
      <Route
        path="employers/:employerUuid/sign-up"
        element={<BrokerPortalSignup />}
      />

      <Route
        path="employers/:employerUuid"
        element={<BrokerPortalEmployerMainWrapper />}
      >
        <Route index element={<Navigate to="employees" replace />} />
        <Route path="invoices" element={<EmployerInvoices feature="" />} />
        <Route path="employees" element={<EmployerDetails feature="" />} />
        <Route
          path="employees/:employeeUuid"
          element={<EmployerEmployeeMainWrapper />}
        >
          <Route index element={<Navigate to="employee-details" replace />} />
          <Route
            path="employee-details"
            element={<EmployeeBasicDetails feature="" />}
          />
        </Route>
        <Route path="commission-breakdown" element={<CommissionBreakdown />} />
        <Route path="enrollment-history" element={<EnrollmentHistory />} />
        <Route
          path="commission-invoice"
          element={<EmployerCommissionInvoices />}
        />
        <Route
          path="employee-uploads"
          element={<EmployeeUploads feature="" />}
        />
        <Route
          path="employee-uploads/:uploadUuid"
          element={<ProcessedRows />}
        />
        <Route
          path="employee-uploads/:uploadUuid/view-all"
          element={<DetailedRows />}
        />
      </Route>
      <Route
        path="commission-invoices"
        element={<BrokerPortalCommissionInvoices />}
      />
      <Route
        path="commission-invoices/:invoiceUuid"
        element={<CommissionInvoiceDetail />}
      />
      <Route path="payment-options" element={<BrokerPortalPaymentOptions />} />
      <Route path="settings" element={<Agreements />} />
      <Route path="settings/agreement" element={<Agreements />} />
    </Route>
    <Route element={<MainRoute />}>
      <Route
        path="/broker-portal/agent/:agentUuid/commission-invoices/invoice/:invoiceUuid/:mode?"
        element={<BrokerInvoiceLayout />}
      />
      <Route
        path="/broker-portal/agent/:agentUuid/employers/:employerUuid/invoice/:invoiceUuid/:mode?"
        element={<EmployerInvoiceLayout />}
      />
    </Route>
  </>
);

export default BrokerPortalRoutes;
